export const DOMAIN = process.env.REACT_APP_API_URL || 'https://quequan.vn:8081'

export const IMGBB_API = 'https://api.imgbb.com/1/upload?key=f0dfc9c9f8249179184020089501e47e'

export const api = {
	LOGIN: `${DOMAIN}/login`,
	//----ADMIN----
	GET_ROLES_ADMIN: `${DOMAIN}/admin/roles`,
	DELETE_ROLE_ADMIN: `${DOMAIN}/admin/delete-role`,
	GET_ACTIONS_ADMIN: `${DOMAIN}/admin/actions`,
	POST_ROLE_ADMIN: `${DOMAIN}/admin/post-role`,
	GET_ADMIN_ACCOUNT: `${DOMAIN}/admin-account`,
	GET_STORES_ADMIN: `${DOMAIN}/admin/stores`,
	GET_STORES_MANAGER_ADMIN: `${DOMAIN}/admin/storesManager`,
	SIGNUP_USER_ADMIN: `${DOMAIN}/admin/signup-user`,
	SIGNUP_STORE_ADMIN: `${DOMAIN}/admin/signup-store`,
	DELETE_STORE_ADMIN: `${DOMAIN}/admin/delete-store`,
	DELETE_USER_ADMIN: `${DOMAIN}/admin/delete-user`,
	POST_TAG_ADMIN: `${DOMAIN}/admin/add-tag`,
	DELETE_TAG_ADMIN: `${DOMAIN}/admin/delete-tag`,
	UPDATE_TAG_ADMIN: `${DOMAIN}/admin/update-tag`,
	COMPARE_STORES_2_TIMES: `${DOMAIN}/admin/statistics/compare-stores`,
	IMPORT_STOCK: `${DOMAIN}/import-stock`,
	GET_INVENTORY: `${DOMAIN}/stock/inventory`,
	GET_STOCK_HISTORY: `${DOMAIN}/stock/history`,
	GET_HISTORY_BY_DATE: `${DOMAIN}/stock/history-by-date`,
	IMPORT_EXPORT_STOCK: `${DOMAIN}/import-export-stock`,
	GET_PRODUCTS: `${DOMAIN}/products`,
	GET_REQUESTS: `${DOMAIN}/requests`,
	DELETE_REQUEST: `${DOMAIN}/delete-request`,
	APPROVE_REQUEST: `${DOMAIN}/approve-request`,
	CONFIRM_REQUEST: `${DOMAIN}/confirm-request`,
	COMPLETE_REQUEST: `${DOMAIN}/complete-request`,
	BILLING_ORDER: `${DOMAIN}/billing-order`,
	DELETE_PRODUCT: `${DOMAIN}/delete-product`,
	GET_MAIN_STOCK: `${DOMAIN}/main-stock`,
	EDIT_MAIN_STOCK: `${DOMAIN}/main-stock/edit`,
	GET_FORECAST_STOCK: `${DOMAIN}/stock/forecast`,
	APPROVE_GUEST_ORDER_ADMIN: `${DOMAIN}/admin/guest-order/approve`,
	DELETE_GUEST_ORDER_ADMIN: `${DOMAIN}/admin/guest-order/delete`,
	GET_ALL_GUEST_ORDERS_QUANTITY: `${DOMAIN}/admin/guest-order/quantity`,
	GET_ALL_STORE: `${DOMAIN}/admin/stores`,
	ADMIN_STOCK_HISTORY_BY_DATE: `${DOMAIN}/admin/stock/history-by-date`,

	//----DIRECTOR----
	GET_ROLES_DIRECTOR: `${DOMAIN}/director/roles`,
	//----STORE MANAGER-----
	GET_ROLES_STORE_MANAGER: `${DOMAIN}/storeManager/roles`,
	GET_USERS_STORE_MANAGER: `${DOMAIN}/storeManager/users`,
	GET_USERS_STORE_MANAGER_WITH_SM: `${DOMAIN}/storeManager/users-with-sm`,
	SIGNUP_USER_STORE_MANAGER: `${DOMAIN}/storeManager/signup-user`,
	DELETE_USER_STORE_MANAGER: `${DOMAIN}/storeManager/delete-user`,
	COMPARE_STORE_2_TIMES: `${DOMAIN}/store-manager/statistics/compare`,
	GET_STATISTICS_GROW_STORE_MANAGER: `${DOMAIN}/store-manager/statistics/grow`,
	GET_STATISTICS_STORE_MANAGER: `${DOMAIN}/store-manager/statistics/store`,
	GET_STATISTICS_BY_STORE_ADMIN: `${DOMAIN}/admin/statistics`,
	GET_GUEST_ORDERS_STORE_MANAGER: `${DOMAIN}/storeManager/guest-order`,
	GET_GUEST_ORDERS_QUANTITY_STORE_MANAGER: `${DOMAIN}/storeManager/guest-order/quantity`,
	GET_CONFIRM_ORDERS_QUANTITY_STORE_MANAGER: `${DOMAIN}/storeManager/confirm-order/quantity`,
	GET_SCHEDULE_ORDERS_QUANTITY_STORE_MANAGER: `${DOMAIN}/storeManager/schedule-order/quantity`,
	APPROVE_GUEST_ORDERS_STORE_MANAGER: `${DOMAIN}/storeManager/guest-order/approve`,
	DELETE_GUEST_ORDERS_STORE_MANAGER: `${DOMAIN}/storeManager/guest-order/delete`,
	DELETE_REQUEST_FROM_STORE: `${DOMAIN}/store-delete-request`,

	//SHIPPING SERVICE
	GET_ALL_SHIPPING_SERVICES: `${DOMAIN}/shipping-services`,
	CREATE_SHIPPING_SERVICE: `${DOMAIN}/create-shipping-service`,
	DELETE_SHIPPING_SERVICE: `${DOMAIN}/delete-shipping-service`,
	HANDLE_SHIPPING_FEE: `${DOMAIN}/order/handle-shipping-fee`,
	UPDATE_SHIPPING_FEE: `${DOMAIN}/order/update-shipping-fee`,
	HANDLE_SHIPPING_SERVICE: `${DOMAIN}/order/handle-shipping-service`,
	UNDO_SHIPPING_SERVICE: `${DOMAIN}/order/undo-shipping-service`,
	START_SHIPPING_SERVICE: `${DOMAIN}/orders/start-shipping-service`,
	END_SHIPPING_SERVICE: `${DOMAIN}/orders/end-shipping-service`,

	//----STAFF----
	GET_STAFF_STATISTICS: `${DOMAIN}/staff/statistics`,

	//----USER----
	CHANGE_PASSWORD: `${DOMAIN}/user/change-password`,
	FORGOT_PASSWORD: `${DOMAIN}/user/forgot-password`,
	GET_MESSAGES: `${DOMAIN}/chat`,
	GET_NOTIFICATIONS: `${DOMAIN}/notification`,
	GET_ORDERS: `${DOMAIN}/orders`,
	GET_TODAY_ORDERS: `${DOMAIN}/orders/create/today`,
	GET_TOTAL_ORDERS: `${DOMAIN}/orders/total`,
	GET_ORDERS_QUANTITY: `${DOMAIN}/orders/quantity`,
	GET_ORDERS_WEIGHT: `${DOMAIN}/orders/weight`,
	GET_CREATE_ORDERS: `${DOMAIN}/orders/create`,
	GET_PRODUCE_ORDERS: `${DOMAIN}/orders/produce`,
	GET_PRODUCING_SHIPPING_SERVICE_ORDERS: `${DOMAIN}/orders/producing-shipping-service`,
	GET_START_SHIPPING_SERVICE_ORDERS: `${DOMAIN}/orders/start-shipping-service`,
	GET_END_SHIPPING_SERVICE_ORDERS: `${DOMAIN}/orders/end-shipping-service`,
	GET_SHIP_ORDERS: `${DOMAIN}/orders/ship`,
	GET_SUCCESS_ORDERS: `${DOMAIN}/orders/success`,
	PUT_TRANSFER_ORDER: `${DOMAIN}/order/transfer`,
	POST_CREATE_ORDER: `${DOMAIN}/order/create`,
	POST_CREATE_TIMER_ORDER: `${DOMAIN}/order/create-timer`,
	PUT_UPDATE_ORDER: `${DOMAIN}/order/update`,
	POST_START_PRODUCE_ORDER: `${DOMAIN}/order/start-produce`,
	CONFIRM_SUCCESS_QUICK_ORDER: `${DOMAIN}/order/confirm-success-quick-order`,
	POST_END_PRODUCE_ORDER: `${DOMAIN}/order/end-produce`,
	POST_START_SHIP_ORDER: `${DOMAIN}/order/start-ship`,
	POST_END_SHIP_ORDER: `${DOMAIN}/order/end-ship`,
	GET_NOTES: `${DOMAIN}/user/notes`,
	POST_NOTE: `${DOMAIN}/user/add-note`,
	DELETE_NOTE: `${DOMAIN}/user/delete-note`,
	DELETE_SCHEDULE: `${DOMAIN}/user/delete-schedule`,
	UPDATE_SCHEDULE: `${DOMAIN}/user/update-schedule`,

	// ----CUSTOMER----
	GET_CUSTOMERS_DATA: `${DOMAIN}/customer/data`,
	POST_ORDER_BY_SLUG: `${DOMAIN}/customer/order`,

	GET_STOCK_BY_STORE: `${DOMAIN}/api/stock`,
	GET_HISTORY_BY_STORE: `${DOMAIN}/api/history`,
	GET_REQUESTS_BY_STORE: `${DOMAIN}/api/requests`,

	GET_FRESH_HISTORY: `${DOMAIN}/sub-stock/fresh-history`,
	GET_PRODUCT_STOCK: `${DOMAIN}/sub-stock/check-product-stock`,
	GET_FRESH_STOCK: `${DOMAIN}/sub-stock/check-fresh-stock`,
	GET_SUB_STOCK: `${DOMAIN}/sub-stock`,

	// Add Zalo Mini App endpoints
	ZALO_MINI_APP_PRODUCT_LIST: `${DOMAIN}/customer/zaloproducts`,
	ZALO_MINI_APP_CREATE_PRODUCT: `${DOMAIN}/customer/zaloproducts`,
	ZALO_MINI_APP_CONFIG: `${DOMAIN}/customer/zaloconfig`,
	ZALO_MINI_APP_EDIT_PRODUCT: (id) => `${DOMAIN}/customer/zaloproducts/${id}`,
	ZALO_MINI_APP_DELETE_PRODUCT: (id) => `${DOMAIN}/customer/zaloproducts/${id}`,
	ZALO_MINI_APP_UPDATE_CONFIG: `${DOMAIN}/customer/zaloconfig`,

	// Customer endpoints
	GET_ZALO_CUSTOMERS: `${DOMAIN}/customer/zalocustomerall`,
	GET_CUSTOMER_TOTAL_MEMBERS: `${DOMAIN}/customer/totalmembers`,
	GET_CUSTOMER_REFERRAL: `${DOMAIN}/customer/referralacc`,
	GET_CUSTOMER_POINTS: `${DOMAIN}/customer/zalo-customer-point`,
	GET_ALL_POINT: `${DOMAIN}/customer/allpoint`,
	GET_CUSTOMER_HISTORY_POINTS: `${DOMAIN}/customer/get-history-points`,

	//----STOCK MANAGEMENT----
	GET_STOCK: `${DOMAIN}/tonkho`,
	GET_VANI_STOCK: `${DOMAIN}/tonkho`,
	GET_VANI_HISTORY: `${DOMAIN}/tonkho/history`,

	// Cafe (productId: 9)
	GET_CAFE_STOCK: `${DOMAIN}/tonkho`,
	GET_CAFE_HISTORY: `${DOMAIN}/tonkho/history`,

	// Bánh Giòn (productId: 10)
	GET_BANH_GION_STOCK: `${DOMAIN}/tonkho`,
	GET_BANH_GION_HISTORY: `${DOMAIN}/tonkho/history`,

	// Chả Giò (productId: 16)
	GET_CHA_GIO_STOCK: `${DOMAIN}/tonkho`,
	GET_CHA_GIO_HISTORY: `${DOMAIN}/tonkho/history`,

	GET_PRODUCT_HISTORY: `${DOMAIN}/sub-stock/product-history/store`,

	// Tồn kho endpoints
	POST_IMPORT_STOCK: `${DOMAIN}/tonkho/increase`,
	POST_CHECK_STOCK: `${DOMAIN}/tonkho/update`,

	GET_CUSTOMER_ORDERS: `${DOMAIN}/customer/listorder`,
	GET_ORDER_DETAIL: `${DOMAIN}/customer/order-detail`,

	// internal sale
	POST_CREATE_INTERNAL_SALE_ORDER: `${DOMAIN}/storeManager/cross-store-order/maker`,
	PUT_UPDATE_INTERNAL_SALE_ORDER: `${DOMAIN}/storeManager/cross-store-order/maker`,
	DELETE_INTERNAL_SALE_ORDER: `${DOMAIN}/storeManager/cross-store-order/maker`,
	GET_INTERNAL_SALE_ORDERS: `${DOMAIN}/storeManager/cross-store-order/maker`,
	GET_INTERNAL_SALE_ORDER_REQUESTS: `${DOMAIN}/storeManager/cross-store-order/checker`,
	POST_INTERNAL_SALE_ORDER_REQUEST: `${DOMAIN}/storeManager/cross-store-order/checker`,

	GET_INTERNAL_SALE_ORDER_CHECKER_ACCEPT: `${DOMAIN}/storeManager/cross-store-order/checker-accept-list`,

	// VAT
	EXPORT_VAT: `${DOMAIN}/order/export-vat`,

	// Cashflow
	CASHFLOW_BANK_ACCOUNTS: `${DOMAIN}/cashflow/bank-accounts`,
	CASHFLOW_EXPENSE_CATEGORIES: `${DOMAIN}/cashflow/expense-categories`,
	CASHFLOW_EXPENSE_CATEGORY_DEFAULTS: `${DOMAIN}/cashflow/expense-categories/defaults`,
	CASHFLOW_EXPENSES: `${DOMAIN}/cashflow/expenses`,
	CASHFLOW_INCOMES: `${DOMAIN}/cashflow/incomes`,
	CASHFLOW_ORDERS: `${DOMAIN}/cashflow/orders`,
	CASHFLOW_PAYMENT_CONFIRMATIONS: `${DOMAIN}/cashflow/payment-confirmations`,
	CASHFLOW_SUMMARY: `${DOMAIN}/cashflow/summary`,
	CASHFLOW_REPORTS: `${DOMAIN}/cashflow/reports`,
	CASHFLOW_DAILY_REPORT: `${DOMAIN}/cashflow/daily-report`,
	CASHFLOW_DAILY_REPORT_PDF :`${DOMAIN}/cashflow/daily-report/pdf`,
	CASHFLOW_SHIPPING_ORDERS: `${DOMAIN}/cashflow/shipping-orders`,
}
